// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3u8G8","notes":"Notes_notes__34YWm","note":"Notes_note__19zzo","markdown":"Notes_markdown__1lOWB"};